import TagBadge from "components/tags/TagBadge";
import { EMPTY } from "utils/format";

const formatLocation = (user) => {
  const parts = [user?.address, user?.city, user?.state, user?.zip].filter(Boolean);
  if (parts.length > 0) return parts.join(", ");
  return user?.memberLocation || "";
};

const calculateAge = (user) => {
  if (user?.age) return user.age;
  const dob = user?.dob || user?.dateOfBirth;
  if (!dob) return "";
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

const Details = ({ user }) => {
  const tags = user?.tags || [];
  const detailItems = [
    { label: "Email Address", value: user?.email },
    { label: "Contact Phone", value: user?.contactPhone || user?.phone },
    { label: "Gender", value: user?.gender, capitalize: true },
    { label: "Address", value: formatLocation(user) },
    { label: "Age", value: calculateAge(user) },
    {
      label: "Family Relationship",
      value: user?.familyRelationship || user?.maritalStatus,
      capitalize: true,
    },
    {
      label: "Tags",
      value:
        tags.length > 0 ? (
          <span className="flex flex-wrap justify-end gap-2">
            {tags.map((tag) => (
              <TagBadge key={tag.id} tag={tag} />
            ))}
          </span>
        ) : null,
    },
  ];

  return (
    <dl className="divide-y divide-line">
      {detailItems.map((item) => (
        <div key={item.label} className="flex items-center justify-between gap-4 py-3">
          <dt className="text-sm text-fg-muted">{item.label}</dt>
          <dd
            className={`text-right text-sm font-medium text-fg ${
              item.capitalize ? "capitalize" : ""
            }`}
          >
            {item.value === null || item.value === undefined || item.value === ""
              ? EMPTY
              : item.value}
          </dd>
        </div>
      ))}
    </dl>
  );
};

export default Details;
